<div class="mt-6 overflow-hidden rounded-md border border-zinc-100 shadow shadow-slate-200 xl:mt-8">
  <div class="flex h-16 items-center border-b border-zinc-100 px-4 py-4 md:px-6">
    <div class="flex-1 uppercase">{{ 'profile.profileData.headline' | transloco }}</div>

    @if (isAdmin()) {
      @if (isEditing()) {
        <p-button
          severity="secondary"
          icon="pi pi-times"
          [rounded]="true"
          [text]="true"
          size="large"
          class="max-md:translate-x-4"
          [attr.aria-label]="'global.close' | transloco"
          (onClick)="toggleEditForm()"></p-button>
      } @else {
        <p-button
          data-testid="edit-profile-button"
          severity="secondary"
          icon="pi pi-pencil"
          [rounded]="true"
          [text]="true"
          size="large"
          class="max-md:translate-x-4"
          [attr.aria-label]="'global.close' | transloco"
          (onClick)="toggleEditForm()"></p-button>
      }
    }
  </div>

  <div class="bg-zinc-50 px-4 pb-12 pt-8 md:px-6" data-testid="profile-data-view">
    @if (loading()) {
      <p>
        {{ 'profile.loading' | transloco }}
        <app-loading-dots class="inline-flex" />
      </p>
    } @else if (user()) {
      @if (isEditing()) {
        <app-profile-data-form [user]="user()" (save)="onFormSave($event)" (dismiss)="toggleEditForm()" />
      } @else {
        <!-- contact person -->
        <p class="truncate">
          @if (salutationKey()) {
            {{ (salutationKey() | transloco) + ' ' }}
          }
          {{ user()?.profile?.first_name }} {{ user()?.profile?.last_name }}
        </p>
        <p class="truncate">{{ user()?.profile?.email }}</p>
        <p class="truncate">{{ user()?.profile?.phone_number }}</p>

        <!-- company address -->
        <p class="mt-8 truncate font-bold">{{ user()?.company?.name }}</p>
        <p class="mt-2 truncate">{{ user()?.company?.address_line_1 }}</p>
        @if (user()?.company?.address_line_2) {
          <p class="truncate">{{ user()?.company?.address_line_2 }}</p>
        }

        <p class="truncate whitespace-nowrap">{{ user()?.company?.zip }} {{ user()?.company?.city }}</p>
        @if (user()?.company?.country_code) {
          <p class="truncate">{{ user()?.company?.country_code }}</p>
        }

        <!-- company data -->
        <dl class="mt-8 grid grid-cols-[170px_auto] gap-x-1 gap-y-1">
          <dt>{{ 'profile.profileData.vatNumber' | transloco }}</dt>
          <dd class="truncate">{{ user()?.company?.vat_number }}</dd>

          <dt>{{ 'profile.profileData.numOfEmployees' | transloco }}</dt>
          <dd class="truncate">{{ user()?.company?.num_of_employees }}</dd>

          <dt>{{ 'profile.profileData.numOfPlatforms' | transloco }}</dt>
          <dd class="truncate">{{ user()?.company?.num_of_platforms }}</dd>
        </dl>

        <!-- partner code -->
        <p class="mt-8 truncate font-bold">Partner Code:</p>
        <p class="mt-2 truncate">{{ user()?.company?.partner_code || ('user.partnerCode.default' | transloco) }}</p>
      }
    } @else {
      <p>{{ 'profile.notFound' | transloco }}</p>
    }
  </div>
</div>

@if (isAdmin()) {
  <div class="mt-4 text-right">
    <button class="text-stone-400 underline hover:text-stone-500" (click)="onDeleteAccountClicked()">
      {{ 'profile.deleteAccount.button' | transloco }}
    </button>
  </div>
}
